import { Api } from '../api';
import { recipients } from '../endpoints';
import type { ApiPaginate, ApiResponse } from '../../models';
import type {
  CreateRecipientRequest,
  GetRecipientRequest,
  GetRecipientMandatoryFieldsRequest,
  GetRecentRecipientRequest,
  RecipientResponse,
  UpdateRecipientRequest,
} from './models';

export class RecipientsApi extends Api {
  static getRecipients = (request: GetRecipientRequest, signal?: AbortSignal) =>
    this.get<ApiPaginate<RecipientResponse[]>>({ url: recipients.getRecipients(), queryParams: request, signal });

  static getRecipient = (id: string, signal?: AbortSignal) =>
    this.get<ApiResponse<RecipientResponse>>({ url: recipients.getRecipient(), queryParams: { id }, signal });

  static getRecentRecipients = (request: GetRecentRecipientRequest, signal?: AbortSignal) =>
    this.get<ApiResponse<RecipientResponse[]>>({ url: recipients.getRecentRecipients(), queryParams: request, signal });

  static getMandatoryFields = (request: GetRecipientMandatoryFieldsRequest, signal?: AbortSignal) =>
    this.get<ApiResponse<string[]>>({ url: recipients.getMandatoryFields(), queryParams: request, signal });

  static createRecipient = (request: CreateRecipientRequest, signal?: AbortSignal) =>
    this.post<CreateRecipientRequest, ApiResponse<RecipientResponse>>({ url: recipients.createRecipient(), data: request, signal });

  static updateRecipient = (request: UpdateRecipientRequest, signal?: AbortSignal) =>
    this.put<UpdateRecipientRequest, ApiResponse<RecipientResponse>>({ url: recipients.updateRecipient(), data: request, signal });

  static deleteRecipient = (id: string) => this.delete<null, ApiResponse<RecipientResponse>>({ url: recipients.deleteRecipient(id) });
}
